import React, { useState, useRef } from "react";
import "./css/Navigation-Bar.css";
import { useTranslation } from "react-i18next";

export default function NavbarMain() {
  const { t, i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const LINKS = [
    { label: t("nav.home"), href: "/home" },
    { label: t("nav.services"), href: "/service" },
    { label: t("nav.special_ops"), href: "/special-ops" },
    { label: t("nav.team"), href: "/team" },
    { label: t("nav.events"), href: "/events" },
    { label: t("nav.articles"), href: "/articles" },
    { label: t("nav.contact"), href: "/contact" },
  ];

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  React.useEffect(() => {
    const isHomePage =
      window.location.pathname === "/" ||
      window.location.pathname === "/home" ||
      window.location.pathname === "/contact" ||
      window.location.pathname === "/events" ||
      window.location.pathname === "/service" ||
      window.location.pathname === "/articles" ||
      window.location.pathname === "/team";
    if (!isHomePage) {
      setIsScrolled(true);
      return;
    }
    const onScroll = () => setIsScrolled(window.scrollY > 80);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header style={{fontFamily: "Prompt, sans-serif"}}
      className={`mhp-nav ${isScrolled ? "mhp-nav--solid" : "mhp-nav--glass"}`}
    >
      <div className="mhp-nav__inner">
        {/* Left: Brand */}
        <a href="/home" className="mhp-brand" style={{marginRight: "20px", marginLeft: "20px"}}>
          Thai Tax &amp; Law
        </a>
        
        <button
          className="mhp-menu-btn"
          aria-label="Open menu"
          aria-controls="mhp-mobile-menu"
          aria-expanded={mobileOpen ? "true" : "false"}
          onClick={() => setMobileOpen((v) => !v)}
        >
          <span className={`mhp-menu-icon ${mobileOpen ? "is-open" : ""}`} aria-hidden="true"></span>
        </button>

        {/* Center: Links with bullets */}
        <nav className="mhp-links" aria-label="Primary" style={{fontSize: "18px"}}>
          {LINKS.map((item, i) => {
            const isActive = window.location.pathname === item.href;
            return (
              <a 
                key={item.href} 
                href={item.href} 
                className={`mhp-link ${isActive ? "is-active" : ""}`}
              >
                {item.label}
                {i < LINKS.length - 1 && <span className="mhp-bullet">•</span>}
              </a>
            );
          })}
        </nav>

        {/* Right: Language Switcher & CTA */}
        <div className="mhp-desktop-lang" style={{ alignItems: "center", gap: "15px", marginRight: "30px" }}>
          <div style={{ 
            display: "flex", alignItems: "center", gap: "10px", 
            padding: "6px 14px", borderRadius: "50px",
            background: "rgba(11, 18, 32, 0.85)", // เข้มขึ้นเพื่อให้ตัดกับทุุกพื้นหลัง
            border: "1px solid rgba(212, 175, 55, 0.3)", // ขอบทองจางๆ ให้ดูแพง
            boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
            backdropFilter: "blur(10px)"
          }}>
            <button 
              onClick={() => changeLanguage("th")}
              style={{
                background: "none",
                color: i18n.language === "th" ? "#D4AF37" : "rgba(255,255,255,0.5)",
                border: "none", padding: "0", cursor: "pointer", 
                fontSize: "13px", fontWeight: "800",
                transition: "all 0.3s ease"
              }}
            >
              TH
            </button>
            <div style={{ width: "1px", height: "12px", background: "rgba(212, 175, 55, 0.2)" }} />
            <button 
              onClick={() => changeLanguage("en")}
              style={{
                background: "none",
                color: i18n.language === "en" ? "#D4AF37" : "rgba(255,255,255,0.5)",
                border: "none", padding: "0", cursor: "pointer", 
                fontSize: "13px", fontWeight: "800",
                transition: "all 0.3s ease"
              }}
            >
              EN
            </button>
          </div>

          <a href="/contact" className="mhp-cta" style={{ whiteSpace: "nowrap" }}>
            {t("nav.consult")}
            <span className="mhp-cta__icon" aria-hidden="true">↗</span>
          </a>
        </div>
      </div>

      <div
        id="mhp-mobile-menu"
        className={`mhp-mobile ${mobileOpen ? "is-open" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-label="Main menu"
      >
        <nav className="mhp-mobile__nav">
          <div style={{ display: "flex", justifyContent: "center", marginBottom: "25px" }}>
            <div style={{ 
              display: "flex", alignItems: "center", gap: "5px", 
              padding: "4px", borderRadius: "50px",
              background: "#111827", // สีเข้มให้ตัดกับตัวเมนูขาว
              border: "1px solid rgba(0,0,0,0.1)",
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
            }}>
              <button 
                onClick={() => { changeLanguage("th"); setMobileOpen(false); }} 
                style={{ 
                  background: i18n.language === "th" ? "#D4AF37" : "transparent", 
                  color: i18n.language === "th" ? "#fff" : "#666", 
                  border: "none", padding: "8px 25px", borderRadius: "50px", 
                  fontWeight: "800", fontSize: "14px", cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                TH
              </button>
              <button 
                onClick={() => { changeLanguage("en"); setMobileOpen(false); }} 
                style={{ 
                  background: i18n.language === "en" ? "#D4AF37" : "transparent", 
                  color: i18n.language === "en" ? "#fff" : "#666", 
                  border: "none", padding: "8px 25px", borderRadius: "50px", 
                  fontWeight: "800", fontSize: "14px", cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                EN
              </button>
            </div>
          </div>
          {LINKS.map((item) => {
            const isActive = window.location.pathname === item.href;
            return (
              <a
                key={item.href}
                href={item.href}
                className={`mhp-mobile__link ${isActive ? "is-active" : ""}`}
                onClick={() => setMobileOpen(false)}
              >
                {item.label}
              </a>
            );
          })}
          <a href="/contact" className="mhp-mobile__cta" onClick={() => setMobileOpen(false)}>
            {t("nav.consult")}
          </a>
        </nav>
      </div>
    </header>
  );
}
